import { render } from "./TheCounter.vue?vue&type=template&id=b28cf4d6&scoped=true"
import script from "./TheCounter.vue?vue&type=script&lang=js"
export * from "./TheCounter.vue?vue&type=script&lang=js"

import "@/assets/styles/counter.scss?vue&type=style&index=0&id=b28cf4d6&lang=scss&scoped=true"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28cf4d6"]])

export default __exports__